/**
 * Remove element at index `index` and return the new array.
 */
export const removeElementByIndex = (arr: unknown[], index: number) => {
  const resultArr = [...arr];
  resultArr.splice(index, 1);
  return resultArr;
};
